import React, { useState, useEffect } from 'react';
import { Button, Form, Dropdown, Modal, ListGroup } from 'react-bootstrap';
import { FaEye, FaTrash } from 'react-icons/fa';
import { TbListDetails } from 'react-icons/tb';
import './deptannouncements.css';
import { Link } from 'react-router-dom';
import { IoMdAddCircle } from "react-icons/io";
import axios from 'axios';
import moment from 'moment';
import AnnouncementLayout from '../../Components/AnnouncementLayout';
import { MdEditNotifications } from "react-icons/md";
import { RiDeleteBin5Line } from "react-icons/ri";
import { IoNotificationsSharp } from "react-icons/io5";
import { BsChevronRight } from "react-icons/bs";

export default function DeptAnnouncements() {
  // State variables
  const [announcements, setAnnouncements] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [showViewModal, setShowViewModal] = useState(false);
  const [showSeenByModal, setShowSeenByModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [announcementToDelete, setAnnouncementToDelete] = useState(null);
  const [query, setQuery] = useState('');
  const [department, setDepartment] = useState('');
  const [seenByList, setSeenByList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const rowsPerPage = 10;
  const BACKEND_URL = "https://backend.ems.hiradentallab.com";

  // Function to fetch all announcements based on search filters
  const fetchAnnouncements = async (searchQuery = '', dept = '') => {
    setLoading(true);
    try {
      const response = await axios.get('https://backend.ems.hiradentallab.com/api/deptannouncements/search-all', {
        params: {
          query: searchQuery,
          department: dept,
        }
      });
      setAnnouncements(response.data);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching announcements:', error);
      setError(error.message);
      setLoading(false);
    }
  };

  // Fetch announcements when the component mounts or when the search query changes
  useEffect(() => {
    fetchAnnouncements(query, department);
  }, [query, department]);

  // Function to fetch announcement details with seenBy information
  const fetchAnnouncementDetails = async (id) => {
    try {
      const response = await axios.get(`https://backend.ems.hiradentallab.com/api/deptannouncements/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching announcement details:', error);
      return null;
    }
  };

  // Pagination logic
  const handlePageChange = (pageNumber) => setCurrentPage(pageNumber);

  const pageRange = () => {
    const pages = [];
    const totalPages = Math.ceil(announcements.length / rowsPerPage);
    let startPage = Math.max(currentPage - 1, 1);
    let endPage = Math.min(startPage + 2, totalPages);
    if (endPage - startPage < 2) {
      startPage = Math.max(endPage - 2, 1);
    }
    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }
    return pages;
  };

  const handleView = async (item) => {
    const announcementDetails = await fetchAnnouncementDetails(item._id);
    if (announcementDetails) {
      setSelectedItem(announcementDetails);
      setShowViewModal(true);
    }
  };

  const handleViewSeenBy = async (item) => {
    const announcementDetails = await fetchAnnouncementDetails(item._id);
    if (announcementDetails) {
      setSeenByList(announcementDetails.seenBy || []);
      setShowSeenByModal(true);
    }
  };

  const handleDelete = async () => {
    if (!announcementToDelete) return;
    try {
      await axios.delete(`https://backend.ems.hiradentallab.com/api/deptannouncements/${announcementToDelete._id}`);
      alert('Announcement deleted successfully');
      setShowDeleteModal(false);
      setAnnouncementToDelete(null);
      fetchAnnouncements(query, department);
    } catch (error) {
      console.error('Failed to delete announcement:', error);
      alert('Failed to delete announcement');
    }
  };

  const openDeleteModal = (announcement) => {
    setAnnouncementToDelete(announcement);
    setShowDeleteModal(true);
  };

  const handleCloseViewModal = () => {
    setShowViewModal(false);
    setSelectedItem(null);
  };

  const handleCloseSeenByModal = () => {
    setShowSeenByModal(false);
    setSeenByList([]);
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return isNaN(date.getTime())
      ? "N/A"
      : date.toLocaleDateString("en-US", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        });
  };

  const formatDateTime = (dateString) => {
    const date = new Date(dateString);
    return isNaN(date.getTime())
      ? "N/A"
      : date.toLocaleString("en-US", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        });
  };

  // Handle search form submit without page reload
  const handleSearchSubmit = (e) => {
    e.preventDefault();
    fetchAnnouncements(query, department);
  };

  return (
    <AnnouncementLayout>
      <div className='container-fluid'>
        <h2 className="announcement-subtitle">
          <IoNotificationsSharp /> All Department Announcements
        </h2>
        <hr />
        <div className="announcement-container">
          <Link to="/add-dept-announcements" style={{ textDecoration: "none" }}>
            <Button
              variant="primary"
              style={{ marginBottom: "15px", marginLeft: "-0.2%" }}
            >
              <IoMdAddCircle /> Add Announcements
            </Button>
          </Link>
          <div className="filter-container">
            <div className="filter-left">
              <Dropdown className="d-inline mx-0" autoClose="inside">
                <Dropdown.Toggle id="dropdown-autoclose-inside">
                  Show Entries
                </Dropdown.Toggle>
                <Dropdown.Menu className="custom-dropdown-menu">
                  <Dropdown.Item href="#">15</Dropdown.Item>
                  <Dropdown.Item href="#">25</Dropdown.Item>
                  <Dropdown.Item href="#">50</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
            <div className="filter-right">
              <Form className="d-flex" onSubmit={handleSearchSubmit}>
                <Form.Control
                  type="search"
                  placeholder="Search title or message"
                  className="search-bar me-2"
                  value={query}
                  onChange={(e) => setQuery(e.target.value)}
                />
                <Form.Control
                  type="text"
                  placeholder="Department"
                  aria-label="Department"
                  className="search-bar"
                  value={department}
                  onChange={(e) => setDepartment(e.target.value)}
                />
              </Form>
            </div>
          </div>
          <div className="table-responsive">
            {loading ? (
              <p>Loading...</p>
            ) : error ? (
              <p>Error: {error}</p>
            ) : (
              <table className="table table-striped table-style">
                <thead className="announcement-table-header">
                  <tr className="table-header">
                    <th>SR</th>
                    <th>Department</th>
                    <th>Title</th>
                    <th>Created</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {announcements.length > 0 ? (
                    announcements
                      .slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage)
                      .map((item, index) => (
                        <tr key={item._id} style={{ textAlign: "center" }}>
                          <td>{(currentPage - 1) * rowsPerPage + index + 1}</td>
                          <td>{item.department}</td>
                          <td>{item.title}</td>

                          <td>{formatDate(item.createdAt)}</td>
                          <td>
                            <Button
                              style={{
                                backgroundColor: "#007bff",
                                color: "white",
                                border: "none",
                                marginRight: "5px",
                              }}
                              size="sm"
                              onClick={() => handleView(item)}
                            >
                              <FaEye />
                            </Button>
                            <Link to={`/edit-dept-announcement/${item._id}`}>
                              <Button variant="warning" size="sm">
                                <MdEditNotifications />
                              </Button>
                            </Link>{" "}
                            <Button
                              variant="danger"
                              size="sm"
                              onClick={() => openDeleteModal(item)}
                            >
                              <RiDeleteBin5Line />
                            </Button>
                          </td>
                        </tr>
                      ))
                  ) : (
                    <tr>
                      <td colSpan="5">No announcements available</td>
                    </tr>
                  )}
                </tbody>
                <tfoot className="table-footer">
                  <tr className="announcement-table-footer">
                    <td>Total</td>
                    <td>-</td>
                    <td>{announcements.length}</td>
                    <td></td>
                    <td></td>
                  </tr>
                </tfoot>
              </table>
            )}
            <div className="pagination-container">
              <div>
                Showing {(currentPage - 1) * rowsPerPage + 1} to{" "}
                {Math.min(currentPage * rowsPerPage, announcements.length)} of{" "}
                {announcements.length} entries
              </div>
              <nav>
                <ul className="pagination">
                  <li
                    className={`page-item ${
                      currentPage === 1 ? "disabled" : ""
                    }`}
                  >
                    <a
                      href="/#"
                      className="page-link"
                      onClick={(e) => {
                        e.preventDefault();
                        handlePageChange(currentPage - 1);
                      }}
                    >
                      Previous
                    </a>
                  </li>
                  {pageRange().map((pageNumber) => (
                    <li
                      key={pageNumber}
                      className={`page-item ${
                        currentPage === pageNumber ? "active" : ""
                      }`}
                    >
                      <a
                        href="/#"
                        className="page-link"
                        onClick={(e) => {
                          e.preventDefault();
                          handlePageChange(pageNumber);
                        }}
                      >
                        {pageNumber}
                      </a>
                    </li>
                  ))}
                  <li
                    className={`page-item ${
                      currentPage === Math.ceil(announcements.length / rowsPerPage)
                        ? "disabled"
                        : ""
                    }`}
                  >
                    <a
                      href="/#"
                      className="page-link"
                      onClick={(e) => {
                        e.preventDefault();
                        handlePageChange(currentPage + 1);
                      }}
                    >
                      Next
                    </a>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>

        {/* Delete Confirmation Modal */}
        <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
          <Modal.Header closeButton style={{ backgroundColor: "#007bff" }}>
            <Modal.Title style={{ color: "white" }}>Confirm Deletion</Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ backgroundColor: "#f5f5f5" }}>
            Are you sure you want to delete this announcement?
          </Modal.Body>
          <Modal.Footer style={{ backgroundColor: "#007bff" }}>
            <Button variant="light" onClick={() => setShowDeleteModal(false)}>
              Cancel
            </Button>
            <Button variant="danger" onClick={handleDelete}>
              Delete
            </Button>
          </Modal.Footer>
        </Modal>

        {/* View Announcement Modal */}
        <Modal
          show={showViewModal}
          onHide={() => setShowViewModal(false)}
          centered
          size="lg"
          dialogClassName="fancy-modal"
        >
          <Modal.Header closeButton style={{ backgroundColor: "#007bff" }}>
            <Modal.Title style={{ color: "white" }}>{selectedItem?.title}</Modal.Title>
          </Modal.Header>
          <Modal.Body className="fancy-modal-body">
            {selectedItem && (
              <>
                <h5 className="modal-title">{selectedItem.title}</h5>
                <p className="modal-text">{selectedItem.message}</p>
                <p className="modal-detail">
                  <strong>Department:</strong> {selectedItem.department}
                </p>
                <p className="modal-detail">
                  <strong>Created:</strong> {formatDate(selectedItem.createdAt)}
                </p>
                {selectedItem.seenBy && selectedItem.seenBy.length > 0 && (
                  <div className="modal-section">
                    <strong>Seen By:</strong>
                    <ul className="modal-list">
                      <li className="modal-list-item" style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                        <span>
                          {selectedItem.seenBy[0].name || `Unknown User (ID: ${selectedItem.seenBy[0].userId})`} at {formatDateTime(selectedItem.seenBy[0].seenAt)}
                        </span>
                        {selectedItem.seenBy.length > 1 && (
                          <BsChevronRight
                            style={{ color: "#007bff", cursor: "pointer", fontSize: "1.2rem" }}
                            onClick={() => {
                              setSeenByList(selectedItem.seenBy);
                              setShowSeenByModal(true);
                            }}
                          />
                        )}
                      </li>
                    </ul>
                  </div>
                )}
              </>
            )}
          </Modal.Body>
          <Modal.Footer style={{ backgroundColor: "#007bff" }}>
            <Button variant="light" onClick={() => setShowViewModal(false)} className="modal-close-btn">
              Close
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Seen By Details Modal */}
        <Modal
          show={showSeenByModal}
          onHide={() => setShowSeenByModal(false)}
          dialogClassName="fancy-modal-right"
        >
          <Modal.Header closeButton style={{ backgroundColor: "#007bff" }}>
            <Modal.Title style={{ color: "white" }}>Users Who Have Seen</Modal.Title>
          </Modal.Header>
          <Modal.Body className="fancy-modal-body">
            <ul className="modal-list">
              {seenByList.map((user, index) => (
                <li key={index} className="modal-list-item" style={{ padding: "10px", borderBottom: "1px solid #ddd" }}>
                  <strong>{user.name || `Unknown User (ID: ${user.userId})`}</strong> - Seen at {formatDateTime(user.seenAt)}
                </li>
              ))}
            </ul>
          </Modal.Body>
          <Modal.Footer style={{ backgroundColor: "#007bff" }}>
            <Button variant="light" onClick={() => setShowSeenByModal(false)} className="modal-close-btn">
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </AnnouncementLayout>
  );
}